var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.09,
    height: 14.09,
    viewBox: "0 0 14.09 14.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157079",
    "data-name": "Path 157079",
    d: "M17.09,22.5v2.8a1.4,1.4,0,0,1-1.4,1.4H5.9a1.4,1.4,0,0,1-1.4-1.4V22.5",
    transform: "translate(0 -9.607)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157080",
    "data-name": "Path 157080",
    d: "M10.5,15,14,18.5l3.5-3.5",
    transform: "translate(-3.202 -5.604)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157081",
    "data-name": "Path 157081",
    d: "M18,12.893V4.5",
    transform: "translate(-7.205)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1f64e2f71d83235bee697710b88f5537.svg";
export { ForwardRef as ReactComponent };